import { InputNumber } from "antd";
import type { InputNumberProps } from "antd";

/**
 * InputNumber that accepts Italian-style decimals (comma separator), e.g.
 * "3,5". The default AntD InputNumber only accepts a dot separator and
 * silently ignores commas, so users couldn't enter decimal loads. Stored
 * value stays a normal JS number (3.5); only the display/entry uses the comma.
 *
 * `decimalSeparator` is set before the prop spread so a caller can still
 * override it if ever needed.
 */
export default function DecimalInputNumber(props: InputNumberProps<number>) {
  return <InputNumber<number> decimalSeparator="," {...props} />;
}
